module.exports = __webpack_public_path__ + "static/brownPattern-654f3bdaa4af0e723cbf77c82e68c5b3.png";